/**
 * Where the CommandDock is visible (DESIGN.md §4.3 + plan PR-4): the
 * quiet home, and customer / vehicle detail pages. Everywhere else the
 * dock stays MOUNTED but display:none so staged work survives
 * navigation for free.
 *
 * Deliberate delta from the plan's route list: the thread workspace
 * (`/?thread=…`) keeps its own thread-scoped composer — it already
 * pins to the bottom via `--shell-bottom-inset`, and mounting the
 * shop-scoped dock composer there would stack two composers. Unifying
 * them is the PR-14 strangle, not a wrap.
 */
export function dockVisibleFor(pathname: string, search: string): boolean {
  if (new URLSearchParams(search).has('thread')) return false
  if (pathname === '/' || pathname === '/dashboard') return true
  if (/^\/customers\/[^/]+$/.test(pathname) && !pathname.endsWith('/new')) {
    return true
  }
  if (
    /^\/vehicles\/[^/]+$/.test(pathname) &&
    !pathname.endsWith('/new') &&
    !pathname.endsWith('/from-photo')
  ) {
    return true
  }
  return false
}
